import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Notes from "./components/Notes";
import Payments from "./components/Payments";
import Contacts from "./components/Contacts";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import IP from "./components/IP";

import { Get_One_From_MongoDB } from "../../../api/Get_One_From_MongoDB";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import { Post_To_MongoDB } from "../../../api/Post_To_MongoDB";
import { Get_limited_Choose_Fields_With_Sort_From_MongoDB } from "../../../api/Get_limited_Choose_Fields_With_Sort_From_MongoDB";

import Emails from "./components/Emails";
import ArrAllProgrammesFiltered from "../../../../arrays/ArrAllProgrammesFiltered";
import SearchSchoolsSetSchool from "../../../components/Search/SearchSchoolsSetSchool";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import WEF from "./components/WEF";
import { Delete_One_From_MongoDB } from "../../../api/Delete_One_From_MongoDB";

const ViewAttendee = () => {
  const { id } = useParams();
  const { logout } = StaffuseAuth();

  // This effect is used to display a warning message when the user tries to leave the page with unsaved changes
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      // Custom message is ignored by most modern browsers, but the assignment is necessary
      e.returnValue =
        "You may have unsaved changes. Are you sure you want to leave?";
      return e.returnValue;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  // Assuming Attendee state is fetched from an API using the id
  const [Attendee, setAttendee] = useState({
    _id: id,
    BasicInfo: {
      Created_At: "",
      First_Name: "",
      Last_Name: "",
      Gender: "",
      Nationality: "",
      Country: "",
      DOB: "",
      uncleanSchool: "",
      School_id: "",
      ProgrammeTitle: "",
      ProgrammeDate: "",
      ProgrammeVarient: "",
      ProgrammeAge: "15-18",
    },
    OrderInfo: {
      OriginalOrderPlatform: "Manual Entry",
      OriginalOrderNumber: "",
      LineItemPrice: "",
      LineItemDiscount: "",
      Deposit: "",
      Airport_Price: "",
      Accom_Meals: "",
      DiscountCode: "",
      GrossOrNet: "",
    },
    Contacts: [],
    Notes: [],
    MetaData: {
      Reserved: "",
      Archived: "",
      CreatedBy: localStorage.getItem("Username"),
      PrimaryStaff: "",
      Bursary: "",
      Scholarship: "",
      TCS: "",
      Password: "p" + Math.floor(10000000 + Math.random() * 90000000),
    },
    IPInfo: {},
    VISA: {},
    SEFProgress: {},
  });
  console.log(Attendee);
  const [AttendeeOriginal, setAttendeeOriginal] = useState({
    _id: id,
  });
  useEffect(() => {
    if (id !== "AddAttendee") {
      Get_One_From_MongoDB("Registers_2025", "All", id, setAttendee, logout);
      Get_One_From_MongoDB(
        "Registers_2025",
        "All",
        id,
        setAttendeeOriginal,
        logout
      );
    }
  }, []);

  useEffect(() => {
    if (
      Attendee &&
      Attendee.BasicInfo &&
      Attendee.BasicInfo["ProgrammeTitle"] &&
      id !== "AddAttendee"
    ) {
      if (
        Attendee.BasicInfo &&
        Attendee.BasicInfo["ProgrammeTitle"] &&
        Attendee.BasicInfo["ProgrammeTitle"].toLowerCase().includes("summer")
      ) {
        setProgrammeType("SXP");
      } else setProgrammeType("Weekend");
    }
  }, [Attendee.BasicInfo?.ProgrammeTitle]);

  // Functions for handling changes in BasicInfo and OrderInfo
  const handleBasicInfoChange = (e) => {
    setAttendee({
      ...Attendee,
      BasicInfo: { ...Attendee.BasicInfo, [e.target.name]: e.target.value },
    });
  };

  const handleVISAChange = (e) => {
    setAttendee({
      ...Attendee,
      VISA: { ...Attendee.VISA, [e.target.name]: e.target.value },
    });
  };

  const handleOrderInfoChange = (e) => {
    setAttendee({
      ...Attendee,
      OrderInfo: { ...Attendee.OrderInfo, [e.target.name]: e.target.value },
    });
  };

  const handleMetaDataChange = (e) => {
    setAttendee({
      ...Attendee,
      MetaData: { ...Attendee.MetaData, [e.target.name]: e.target.value },
    });
  };

  const [ProgrammeType, setProgrammeType] = useState("SXP");
  const handleAgeChange = (e) => {
    setAttendee({
      ...Attendee,
      BasicInfo: {
        ...Attendee.BasicInfo,
        ["ProgrammeTitle"]: "",
        ["ProgrammeDate"]: "",
        ["ProgrammeVarient"]: "",
        ["ProgrammeAge"]: e.target.value,
      },
    });
  };

  const handleTypeChange = (event) => {
    setProgrammeType(event.target.value);
    setAttendee({
      ...Attendee,
      BasicInfo: {
        ...Attendee.BasicInfo,
        ["ProgrammeTitle"]: "",
        ["ProgrammeDate"]: "",
        ["ProgrammeVarient"]: "",
      },
    });
  };
  const handleProgrammeTitleChange = (e) => {
    setAttendee({
      ...Attendee,
      BasicInfo: {
        ...Attendee.BasicInfo,
        ["ProgrammeTitle"]: e.target.value,
        ["ProgrammeDate"]: "",
      },
    });
  };
  const handleProgrammeDateChange = (e) => {
    setAttendee({
      ...Attendee,
      BasicInfo: {
        ...Attendee.BasicInfo,
        ["ProgrammeDate"]: e.target.value,
      },
    });
  };

  // let ArrAllProgrammesFiltered_All = ArrAllProgrammesFiltered(
  //   Attendee?.BasicInfo?.ProgrammeAge,
  //   ProgrammeType,
  //   Attendee.BasicInfo["ProgrammeTitle"],
  //   Attendee.BasicInfo["ProgrammeDate"],
  //   "",
  //   "",
  //   "",
  //   Attendee.BasicInfo["ProgrammeVarient"]
  // ).ArrAllProgrammesFiltered;

  let ArrAllProgrammesFiltered_Varients = ArrAllProgrammesFiltered(
    Attendee?.BasicInfo?.ProgrammeAge,
    ProgrammeType,
    Attendee.BasicInfo["ProgrammeTitle"],
    Attendee.BasicInfo["ProgrammeDate"],
    "",
    "",
    "",
    Attendee.BasicInfo["ProgrammeVarient"]
  ).ArrAllProgrammesFiltered_Varients;

  //Sort varients
  ArrAllProgrammesFiltered_Varients.sort((a, b) => {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  });

  let ArrAllProgrammesFiltered_Titles = ArrAllProgrammesFiltered(
    Attendee?.BasicInfo?.ProgrammeAge,
    ProgrammeType,
    Attendee.BasicInfo["ProgrammeTitle"],
    Attendee.BasicInfo["ProgrammeDate"],
    "",
    "",
    "",
    Attendee.BasicInfo["ProgrammeVarient"]
  ).ArrAllProgrammesFiltered_Titles;

  let ArrAllProgrammesFiltered_Dates = ArrAllProgrammesFiltered(
    Attendee?.BasicInfo?.ProgrammeAge,
    ProgrammeType,
    Attendee.BasicInfo["ProgrammeTitle"],
    Attendee.BasicInfo["ProgrammeDate"],
    "",
    "",
    "",
    Attendee.BasicInfo["ProgrammeVarient"]
  ).ArrAllProgrammesFiltered_Dates;

  // ArrAllProgrammesFiltered(
  //   Attendee?.BasicInfo?.ProgrammeAge,
  //   ProgrammeType,
  //   ProgrammeTitle,
  //   ProgrammeDate,
  //   ProgrammeLength,
  //   ProgrammeAccom,
  //   ProgrammeAirport,
  //   ProgrammeVarient
  // );

  //This is the state for the delete validity
  const [checkdelete, setcheckdelete] = useState(false);
  const [IsArchiving, setIsArchiving] = useState(false);
  const [IsDeleting, setIsDeleting] = useState(false);
  //And deletes
  function handleArchive(e) {
    e.preventDefault();
    //Get Changes
    const OldData = { ...AttendeeOriginal };
    const NewData = { ...Attendee };
    delete OldData.Notes;
    delete NewData.Notes;
    const differences = getDifferences(OldData, NewData);
    const differencesString = JSON.stringify(differences);
    //got Changes
    let data = Attendee;
    delete data._id;
    //Add differencesString to the Notes section
    if (data && data.Notes && Array.isArray(data.Notes)) {
      data.Notes.push({
        Note: differencesString,
        DateTime: new Date().toISOString(),
        Staff_ID: localStorage.getItem("_id"),
      });
    } else {
      data.Notes = [
        {
          Note: differencesString,
          DateTime: new Date().toISOString(),
          Staff_ID: localStorage.getItem("_id"),
        },
      ];
    }

    data.MetaData.Archived = "Yes";
    data.MetaData.ArchivedDateTime = new Date().toISOString();
    delete data._id;
    Update_To_MongoDB_By_ID(
      data,
      "Registers_2025",
      "All",
      setIsArchiving,
      id,
      logout
    );
    setAttendee({
      ...Attendee,
      _id: id,
    });
  }

  function handleDelete(e) {
    e.preventDefault();
    let data = Attendee;
    Delete_One_From_MongoDB(
      data._id,
      "Registers_2025",
      "All",
      setIsDeleting,
      data,
      logout
    );
  }

  //This is the state for the update progress
  const [isSubmitting, setIsSubmitting] = useState(false);
  //get Changes for Note
  const getDifferences = (oldObj, newObj) => {
    const differences = {};
    for (const key in newObj) {
      if (typeof newObj[key] === "object" && newObj[key] !== null) {
        const nestedDifferences = getDifferences(
          oldObj[key] || {},
          newObj[key]
        );
        if (Object.keys(nestedDifferences).length > 0) {
          differences[key] = nestedDifferences;
        }
      } else if (newObj[key] !== oldObj[key]) {
        differences[key] = { old: oldObj[key], new: newObj[key] };
      }
    }
    return differences;
  };

  //And updates
  function handleBasicUpdate(e) {
    e.preventDefault();

    //Get Changes
    const OldData = { ...AttendeeOriginal };
    const NewData = { ...Attendee };
    delete OldData.Notes;
    delete NewData.Notes;
    const differences = getDifferences(OldData, NewData);
    const differencesString = JSON.stringify(differences);
    //got Changes
    let data = Attendee;
    delete data._id;
    //Add differencesString to the Notes section
    if (data && data.Notes && Array.isArray(data.Notes)) {
      data.Notes.push({
        Note: differencesString,
        DateTime: new Date().toISOString(),
        Staff_ID: localStorage.getItem("_id"),
      });
    } else {
      data.Notes = [
        {
          Note: differencesString,
          DateTime: new Date().toISOString(),
          Staff_ID: localStorage.getItem("_id"),
        },
      ];
    }

    Update_To_MongoDB_By_ID(
      data,
      "Registers_2025",
      "All",
      setIsSubmitting,
      id,
      logout
    );
    setAttendee({
      ...Attendee,
      _id: id,
    });
  }
  function handleAddAttendee(e) {
    e.preventDefault();
    let data = Attendee;
    data.BasicInfo.Created_At = new Date().toISOString();
    data.MetaData.CreatedBy = localStorage.getItem("_id");
    delete data._id;
    Post_To_MongoDB(data, "Registers_2025", "All", setIsSubmitting, logout);
  }

  function handleDuplicate(e) {
    e.preventDefault();
    let data = Attendee;
    data.BasicInfo.Created_At = new Date().toISOString();
    data.MetaData.CreatedBy = localStorage.getItem("_id");
    //push note to the notes array
    if (data && data.Notes && Array.isArray(data.Notes)) {
      data.Notes.push({
        Note: "Duplicated from " + id,
        DateTime: new Date().toISOString(),
        Staff_ID: localStorage.getItem("_id"),
      });
    } else {
      data.Notes = [
        {
          Note: "Duplicated from " + id,
          DateTime: new Date().toISOString(),
          Staff_ID: localStorage.getItem("_id"),
        },
      ];
    }
    delete data._id;
    Post_To_MongoDB(data, "Registers_2025", "All", setIsSubmitting, logout);
  }

  //The below gets the staff
  const [Staff, setStaff] = useState([]);
  useEffect(() => {
    Get_limited_Choose_Fields_With_Sort_From_MongoDB(
      "Staff",
      "Users",
      100,
      { Username: 1 },
      setStaff,
      {
        Username: 1,
        Team: 1,
        Level: 1,
        _id: 1,
      },
      logout
    );
  }, []);

  //---------------------------------Components---------------------------------

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
        paddingLeft: "10px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
      }}
    >
      <h1 style={{ marginTop: "0px" }}>View Attendee: {Attendee._id}</h1>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <section>
            <h2>Basic Info :</h2>
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <TextField
                  key="ProgrammeAge"
                  name="ProgrammeAge"
                  label="ProgrammeAge"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={Attendee?.BasicInfo?.ProgrammeAge}
                  onChange={handleAgeChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  select
                >
                  <MenuItem key="15-18" value="15-18">
                    15-18
                  </MenuItem>
                  <MenuItem key="18+" value="18+">
                    18+
                  </MenuItem>
                </TextField>

                <TextField
                  key="ProgrammeType"
                  name="ProgrammeType"
                  label="ProgrammeType"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={ProgrammeType}
                  onChange={handleTypeChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  select
                >
                  <MenuItem key={""} value={""}></MenuItem>

                  <MenuItem key="SXP" value="SXP">
                    SXP
                  </MenuItem>
                  <MenuItem key="Weekend" value="Weekend">
                    Weekend
                  </MenuItem>
                </TextField>

                <>
                  <TextField
                    key="ProgrammeTitle"
                    name="ProgrammeTitle"
                    label="Programme Title"
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    value={
                      Attendee.BasicInfo && Attendee.BasicInfo["ProgrammeTitle"]
                        ? Attendee.BasicInfo["ProgrammeTitle"]
                        : ""
                    }
                    onChange={handleProgrammeTitleChange}
                    InputProps={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                    select
                  >
                    <MenuItem key={""} value={""}></MenuItem>
                    {ArrAllProgrammesFiltered_Titles.map((Varient) => (
                      <MenuItem key={Varient} value={Varient}>
                        {Varient}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    key="ProgrammeDate"
                    name="ProgrammeDate"
                    label="Programme Date"
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    value={
                      Attendee.BasicInfo && Attendee.BasicInfo["ProgrammeDate"]
                        ? Attendee.BasicInfo["ProgrammeDate"]
                        : ""
                    }
                    onChange={handleProgrammeDateChange}
                    InputProps={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                    select
                  >
                    {ArrAllProgrammesFiltered_Dates.map((Varient) => (
                      <MenuItem key={Varient} value={Varient}>
                        {Varient}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    key="ProgrammeVarient"
                    name="ProgrammeVarient"
                    label="Programme Varient"
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    value={
                      Attendee.BasicInfo &&
                      Attendee.BasicInfo["ProgrammeVarient"]
                        ? Attendee.BasicInfo["ProgrammeVarient"].toLowerCase()
                        : ""
                    }
                    onChange={handleBasicInfoChange}
                    InputProps={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                    select
                  >
                    <MenuItem key={""} value={""}></MenuItem>

                    {ArrAllProgrammesFiltered_Varients.map((Varient) => (
                      <MenuItem key={Varient} value={Varient}>
                        {Varient}
                      </MenuItem>
                    ))}
                  </TextField>
                </>
              </Grid>
              <Grid item xs={3}>
                <TextField
                  key="Created_At"
                  name="Created_At"
                  label="Created_At"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Attendee.BasicInfo && Attendee.BasicInfo["Created_At"]
                      ? Attendee.BasicInfo["Created_At"]
                      : ""
                  }
                  onChange={handleBasicInfoChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  disabled
                />
                <TextField
                  key="First_Name"
                  name="First_Name"
                  label="First_Name"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Attendee.BasicInfo && Attendee.BasicInfo["First_Name"]
                      ? Attendee.BasicInfo["First_Name"]
                      : ""
                  }
                  onChange={handleBasicInfoChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="Last_Name"
                  name="Last_Name"
                  label="Last_Name"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Attendee.BasicInfo && Attendee.BasicInfo["Last_Name"]
                      ? Attendee.BasicInfo["Last_Name"]
                      : ""
                  }
                  onChange={handleBasicInfoChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />{" "}
              </Grid>{" "}
              <Grid item xs={3}>
                <TextField
                  key="DOB"
                  name="DOB"
                  label="DOB"
                  variant="outlined"
                  margin="normal"
                  type="date"
                  fullWidth
                  value={
                    Attendee.BasicInfo && Attendee.BasicInfo["DOB"]
                      ? Attendee.BasicInfo["DOB"]
                      : ""
                  }
                  onChange={handleBasicInfoChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="Gender"
                  name="Gender"
                  label="Gender"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Attendee.BasicInfo && Attendee.BasicInfo["Gender"]
                      ? Attendee.BasicInfo["Gender"]
                      : ""
                  }
                  onChange={handleBasicInfoChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  select
                >
                  <MenuItem key={""} value={""}></MenuItem>

                  <MenuItem value="M">M</MenuItem>
                  <MenuItem value="F">F</MenuItem>
                </TextField>
                <TextField
                  key="Number"
                  name="Number"
                  label="Number"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Attendee.BasicInfo && Attendee.BasicInfo["Number"]
                      ? Attendee.BasicInfo["Number"]
                      : ""
                  }
                  onChange={handleBasicInfoChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="Nationality"
                  name="Nationality"
                  label="Nationality"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Attendee.BasicInfo && Attendee.BasicInfo["Nationality"]
                      ? Attendee.BasicInfo["Nationality"]
                      : ""
                  }
                  onChange={handleBasicInfoChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="Country"
                  name="Country"
                  label="Country"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Attendee.BasicInfo && Attendee.BasicInfo["Country"]
                      ? Attendee.BasicInfo["Country"]
                      : ""
                  }
                  onChange={handleBasicInfoChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  key="uncleanSchool"
                  name="uncleanSchool"
                  label="uncleanSchool"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Attendee.BasicInfo && Attendee.BasicInfo["uncleanSchool"]
                      ? Attendee.BasicInfo["uncleanSchool"]
                      : ""
                  }
                  onChange={handleBasicInfoChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />

                <SearchSchoolsSetSchool
                  handleChoose={handleBasicInfoChange}
                  Attendee={Attendee}
                />
              </Grid>
            </Grid>
          </section>
          <section>
            <h2>Meta Data</h2>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <TextField
                  label="Reserved"
                  name="Reserved"
                  variant="outlined"
                  margin="normal"
                  value={
                    Attendee.MetaData && Attendee.MetaData["Reserved"]
                      ? Attendee.MetaData["Reserved"]
                      : ""
                  }
                  onChange={handleMetaDataChange}
                  fullWidth
                  sx={{ marginBottom: "10px" }}
                  InputProps={{
                    style: {
                      backgroundColor:
                        Attendee.MetaData &&
                        Attendee.MetaData.Reserved &&
                        Attendee.MetaData.Reserved === "Yes"
                          ? "rgba(0, 0, 139, 0.5)"
                          : "white", // Change text color based on condition
                    },
                  }}
                  select
                >
                  <MenuItem key={""} value={""}></MenuItem>

                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
                <TextField
                  label="Archived"
                  name="Archived"
                  variant="outlined"
                  margin="normal"
                  value={
                    Attendee.MetaData && Attendee.MetaData.Archived
                      ? Attendee.MetaData.Archived
                      : ""
                  }
                  onChange={handleMetaDataChange}
                  fullWidth
                  disabled={
                    Attendee.MetaData && Attendee.MetaData.Archived === "Yes"
                      ? false
                      : true
                  }
                  sx={{ marginBottom: "10px" }}
                  InputProps={{
                    style: {
                      backgroundColor:
                        Attendee.MetaData &&
                        Attendee.MetaData.Archived &&
                        Attendee.MetaData.Archived === "Yes"
                          ? "rgba(139, 0, 0, 0.5)"
                          : "white", // Change text color based on condition
                    },
                  }}
                  select
                >
                  <MenuItem key={""} value={""}></MenuItem>

                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
                <TextField
                  label="Password (Please always start with a p)"
                  name="Password"
                  variant="outlined"
                  margin="normal"
                  value={
                    Attendee.MetaData && Attendee.MetaData.Password
                      ? Attendee.MetaData.Password
                      : ""
                  }
                  onChange={handleMetaDataChange}
                  fullWidth
                  sx={{ marginBottom: "10px" }}
                  InputProps={{
                    style: {
                      backgroundColor:
                        Attendee.MetaData &&
                        Attendee.MetaData.Password &&
                        Attendee.MetaData.Password === "Yes"
                          ? "rgba(139, 0, 0, 0.5)"
                          : "white", // Change text color based on condition
                    },
                  }}
                ></TextField>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  label="Primary Staff"
                  name="PrimaryStaff"
                  variant="outlined"
                  margin="normal"
                  value={
                    Attendee.MetaData && Attendee.MetaData["PrimaryStaff"]
                      ? Attendee.MetaData["PrimaryStaff"]
                      : ""
                  }
                  InputProps={{
                    style: {
                      backgroundColor: "white", // Change text color based on condition
                    },
                  }}
                  onChange={handleMetaDataChange}
                  fullWidth
                  sx={{ marginBottom: "10px" }}
                  select
                >
                  <MenuItem key={""} value={""}></MenuItem>
                  {Staff.map((Staff) => (
                    <MenuItem key={Staff._id} value={Staff._id}>
                      {Staff.Username ? Staff.Username : ""}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  label="Primary Staff _id"
                  name="PrimaryStaff_id"
                  variant="outlined"
                  margin="normal"
                  value={
                    Attendee.MetaData && Attendee.MetaData["PrimaryStaff"]
                      ? Attendee.MetaData["PrimaryStaff"]
                      : ""
                  }
                  InputProps={{
                    style: {
                      backgroundColor: "white", // Change text color based on condition
                    },
                  }}
                  onChange={handleMetaDataChange}
                  fullWidth
                  sx={{ marginBottom: "10px" }}
                  select
                  disabled
                >
                  <MenuItem key={""} value={""}></MenuItem>
                  {Staff.map((Staff) => (
                    <MenuItem key={Staff._id} value={Staff._id}>
                      {Staff._id}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  key="CreatedBy"
                  name="CreatedBy"
                  label="CreatedBy"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Attendee.MetaData && Attendee.MetaData["CreatedBy"]
                      ? Attendee.MetaData["CreatedBy"]
                      : ""
                  }
                  onChange={handleOrderInfoChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  disabled
                />
                <TextField
                  label="Bursary"
                  name="Bursary"
                  variant="outlined"
                  margin="normal"
                  value={
                    Attendee.MetaData && Attendee.MetaData.Bursary
                      ? Attendee.MetaData.Bursary
                      : ""
                  }
                  onChange={handleMetaDataChange}
                  fullWidth
                  sx={{ marginBottom: "10px" }}
                  InputProps={{
                    style: {
                      backgroundColor:
                        Attendee.MetaData &&
                        Attendee.MetaData.Bursary &&
                        Attendee.MetaData.Bursary === "Yes"
                          ? "rgba(144, 238, 144, 0.5)"
                          : "white", // Change text color based on condition
                    },
                  }}
                  select
                >
                  <MenuItem key={""} value={""}></MenuItem>
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
                <TextField
                  label="Scholarship"
                  name="Scholarship"
                  variant="outlined"
                  margin="normal"
                  value={
                    Attendee.MetaData && Attendee.MetaData.Scholarship
                      ? Attendee.MetaData.Scholarship
                      : ""
                  }
                  onChange={handleMetaDataChange}
                  fullWidth
                  sx={{ marginBottom: "10px" }}
                  InputProps={{
                    style: {
                      backgroundColor:
                        Attendee.MetaData &&
                        Attendee.MetaData.Scholarship &&
                        Attendee.MetaData.Scholarship === "Yes"
                          ? "rgba(144, 238, 144, 0.5)"
                          : "white", // Change text color based on condition
                    },
                  }}
                  select
                >
                  <MenuItem key={""} value={""}></MenuItem>
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
                <TextField
                  label="TCS"
                  name="TCS"
                  variant="outlined"
                  margin="normal"
                  value={
                    Attendee.MetaData && Attendee.MetaData.TCS
                      ? Attendee.MetaData.TCS
                      : ""
                  }
                  onChange={handleMetaDataChange}
                  fullWidth
                  sx={{ marginBottom: "10px" }}
                  select
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                >
                  <MenuItem key={""} value={""}></MenuItem>

                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
              </Grid>
            </Grid>
          </section>
          <section>
            <h2>Order Info</h2>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <TextField
                  key="OriginalOrderPlatform"
                  name="OriginalOrderPlatform"
                  label="OriginalOrderPlatform"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Attendee.OrderInfo &&
                    Attendee.OrderInfo["OriginalOrderPlatform"]
                      ? Attendee.OrderInfo["OriginalOrderPlatform"]
                      : ""
                  }
                  onChange={handleOrderInfoChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="OriginalOrderNumber"
                  name="OriginalOrderNumber"
                  label="OriginalOrderNumber"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Attendee.OrderInfo &&
                    Attendee.OrderInfo["OriginalOrderNumber"]
                      ? Attendee.OrderInfo["OriginalOrderNumber"]
                      : ""
                  }
                  onChange={handleOrderInfoChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />{" "}
                <TextField
                  key="DiscountCode"
                  name="DiscountCode"
                  label="DiscountCode"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Attendee.OrderInfo && Attendee.OrderInfo["DiscountCode"]
                      ? Attendee.OrderInfo["DiscountCode"]
                      : ""
                  }
                  onChange={handleOrderInfoChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />{" "}
              </Grid>
              <Grid item xs={4}>
                <TextField
                  key="GrossOrNet"
                  name="GrossOrNet"
                  label="Gross Or Net"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Attendee.OrderInfo && Attendee.OrderInfo["GrossOrNet"]
                      ? Attendee.OrderInfo["GrossOrNet"]
                      : ""
                  }
                  onChange={handleOrderInfoChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  select
                >
                  <MenuItem key={""} value={""}></MenuItem>
                  <MenuItem value="Gross">Gross</MenuItem>
                  <MenuItem value="Net">Net</MenuItem>
                </TextField>
                <TextField
                  label="Deposit"
                  name="Deposit"
                  variant="outlined"
                  margin="normal"
                  value={
                    Attendee.OrderInfo && Attendee.OrderInfo.Deposit
                      ? Attendee.OrderInfo.Deposit
                      : ""
                  }
                  onChange={handleOrderInfoChange}
                  fullWidth
                  sx={{ marginBottom: "10px" }}
                  InputProps={{
                    style: {
                      backgroundColor: "white", // Change text color based on condition
                    },
                  }}
                  select
                >
                  <MenuItem key={""} value={""}></MenuItem>
                  <MenuItem value="true">Make Deposit (£950) first</MenuItem>
                  <MenuItem value="false">Make full amount payment</MenuItem>
                </TextField>
                <TextField
                  label="ProgrammeAirportArrival"
                  name="ProgrammeAirportArrival"
                  variant="outlined"
                  margin="normal"
                  value={
                    Attendee.OrderInfo &&
                    Attendee.OrderInfo.ProgrammeAirportArrival
                      ? Attendee.OrderInfo.ProgrammeAirportArrival
                      : ""
                  }
                  onChange={handleOrderInfoChange}
                  fullWidth
                  sx={{ marginBottom: "10px" }}
                  InputProps={{
                    style: {
                      backgroundColor: "white", // Change text color based on condition
                    },
                  }}
                  select
                >
                  <MenuItem key={""} value={""}></MenuItem>
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
                <TextField
                  label="ProgrammeAirportDeparture"
                  name="ProgrammeAirportDeparture"
                  variant="outlined"
                  margin="normal"
                  value={
                    Attendee.OrderInfo &&
                    Attendee.OrderInfo.ProgrammeAirportDeparture
                      ? Attendee.OrderInfo.ProgrammeAirportDeparture
                      : ""
                  }
                  onChange={handleOrderInfoChange}
                  fullWidth
                  sx={{ marginBottom: "10px" }}
                  InputProps={{
                    style: {
                      backgroundColor: "white", // Change text color based on condition
                    },
                  }}
                  select
                >
                  <MenuItem key={""} value={""}></MenuItem>
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  key="LineItemPrice"
                  name="LineItemPrice"
                  label="Shopify LineItemPrice"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Attendee.OrderInfo && Attendee.OrderInfo["LineItemPrice"]
                      ? Attendee.OrderInfo["LineItemPrice"]
                      : ""
                  }
                  onChange={handleOrderInfoChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  disabled={true}
                />
                <TextField
                  key="LineItemDiscount"
                  name="LineItemDiscount"
                  label="LineItemDiscount"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Attendee.OrderInfo && Attendee.OrderInfo["LineItemDiscount"]
                      ? Attendee.OrderInfo["LineItemDiscount"]
                      : ""
                  }
                  onChange={handleOrderInfoChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  disabled={true}
                />

                <TextField
                  key="Airport_Price"
                  name="Airport_Price"
                  label="Airport_Price"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Attendee.OrderInfo && Attendee.OrderInfo["Airport_Price"]
                      ? Attendee.OrderInfo["Airport_Price"]
                      : ""
                  }
                  onChange={handleOrderInfoChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="Accom_Meals"
                  name="Accom_Meals"
                  label="Accom_Meals"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Attendee.OrderInfo && Attendee.OrderInfo["Accom_Meals"]
                      ? Attendee.OrderInfo["Accom_Meals"]
                      : ""
                  }
                  onChange={handleOrderInfoChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </section>
          <section>
            <h2>VISA</h2>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <TextField
                  key="Do_you_require_a_VISA_support_letter"
                  name="Do_you_require_a_VISA_support_letter"
                  label="Do_you_require_a_VISA_support_letter"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Attendee.VISA &&
                    Attendee.VISA["Do_you_require_a_VISA_support_letter"]
                      ? Attendee.VISA["Do_you_require_a_VISA_support_letter"]
                      : ""
                  }
                  onChange={handleVISAChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  select
                >
                  <MenuItem key={""} value={""}></MenuItem>

                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={4}>
                {" "}
                <TextField
                  key="Passport_Number"
                  name="Passport_Number"
                  label="Passport_Number"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Attendee.VISA && Attendee.VISA["Passport_Number"]
                      ? Attendee.VISA["Passport_Number"]
                      : ""
                  }
                  onChange={handleVISAChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />{" "}
              </Grid>
              <Grid item xs={4}>
                <TextField
                  key="Has_the_student_ever_been_refused_a_VISA_for_any_county_including_the_UK"
                  name="Has_the_student_ever_been_refused_a_VISA_for_any_county_including_the_UK"
                  label="Has_the_student_ever_been_refused_a_VISA_for_any_county_including_the_UK"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Attendee.VISA &&
                    Attendee.VISA[
                      "Has_the_student_ever_been_refused_a_VISA_for_any_county_including_the_UK"
                    ]
                      ? Attendee.VISA[
                          "Has_the_student_ever_been_refused_a_VISA_for_any_county_including_the_UK"
                        ]
                      : ""
                  }
                  onChange={handleVISAChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  select
                >
                  <MenuItem key={""} value={""}></MenuItem>

                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
                <TextField
                  key="Which_country_or_countries_has_the_VISA_been_rejected_from_previously"
                  name="Which_country_or_countries_has_the_VISA_been_rejected_from_previously"
                  label="Which_country_or_countries_has_the_VISA_been_rejected_from_previously"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Attendee.VISA &&
                    Attendee.VISA[
                      "Which_country_or_countries_has_the_VISA_been_rejected_from_previously"
                    ]
                      ? Attendee.VISA[
                          "Which_country_or_countries_has_the_VISA_been_rejected_from_previously"
                        ]
                      : ""
                  }
                  onChange={handleVISAChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="When_was_the_last_time_the_students_VISA_was_rejected"
                  name="When_was_the_last_time_the_students_VISA_was_rejected"
                  label="When_was_the_last_time_the_students_VISA_was_rejected"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Attendee.VISA &&
                    Attendee.VISA[
                      "When_was_the_last_time_the_students_VISA_was_rejected"
                    ]
                      ? Attendee.VISA[
                          "When_was_the_last_time_the_students_VISA_was_rejected"
                        ]
                      : ""
                  }
                  onChange={handleVISAChange}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </section>
        </Grid>
      </Grid>
      {/* Handle Arrays */}
      <IP Attendee={Attendee} setAttendee={setAttendee} Staff={Staff} />
      <Notes Attendee={Attendee} setAttendee={setAttendee} Staff={Staff} />
      <Payments
        Attendee={Attendee}
        setAttendee={setAttendee}
        Staff={Staff}
        id={id}
      />
      <WEF
        Attendee={Attendee}
        setAttendee={setAttendee}
        Staff={Staff}
        id={id}
      />
      <Contacts Attendee={Attendee} setAttendee={setAttendee} Staff={Staff} />
      {id === "AddAttendee" ? (
        <></>
      ) : (
        <>
          <Emails
            Attendee={Attendee}
            setAttendee={setAttendee}
            Staff={Staff}
            AttendeeOriginal={AttendeeOriginal}
            getDifferences={getDifferences}
            setIsSubmitting={setIsSubmitting}
            isSubmitting={isSubmitting}
            id={id}
          />
        </>
      )}

      <h1>Actions</h1>
      <Button
        type="submit"
        variant="contained"
        sx={{ mt: 3, ml: 1 }}
        disabled={isSubmitting}
        onClick={(e) =>
          id === "AddAttendee" ? handleAddAttendee(e) : handleBasicUpdate(e)
        }
      >
        {isSubmitting
          ? "Submitting..."
          : id === "AddAttendee"
          ? "Add Attendee"
          : "Update Attendee"}
      </Button>
      {id === "AddAttendee" ? (
        <></>
      ) : (
        <Button
          type="submit"
          variant="contained"
          sx={{ mt: 3, ml: 1 }}
          disabled={isSubmitting}
          onClick={(e) => handleDuplicate(e)}
          color="secondary"
        >
          {isSubmitting ? "Duplicating..." : "Duplicate"}
        </Button>
      )}
      {/* Show delete button if archived */}
      {Attendee.MetaData["Archived"] === "Yes" &&
      (localStorage.getItem("Username") === "curtis@investin.org" ||
        localStorage.getItem("Username") === "rebecca@investin.org" ||
        localStorage.getItem("Username") === "amy@investin.org" ||
        localStorage.getItem("Username") ===
          "katherine.tarren@investin.org") ? (
        <Button
          variant="contained"
          sx={{
            mt: 3,
            ml: 1,
            backgroundColor: "red",
            "&:hover": { backgroundColor: "darkred" },
          }}
          onClick={(e) => handleDelete(e)}
          disabled={!Attendee.MetaData["Archived"] === "Yes"}
        >
          {IsDeleting ? "Deleting..." : "D E L E T E !"}
        </Button>
      ) : (
        <></>
      )}
      {/* If not an add, show the archive option */}
      {id === "AddAttendee" ? (
        <></>
      ) : (
        <>
          {!checkdelete ? (
            <Button
              variant="contained"
              sx={{
                mt: 3,
                ml: 1,
                backgroundColor: "red",
                "&:hover": { backgroundColor: "darkred" },
              }}
              onClick={() => setcheckdelete(true)}
            >
              Archive
            </Button>
          ) : (
            <>
              <h2>Reasons</h2>
              <br></br>
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <TextField
                    key="DeleteReason"
                    name="DeleteReason"
                    label="Delete Reason"
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    value={
                      Attendee.MetaData && Attendee.MetaData.DeleteReason
                        ? Attendee.MetaData.DeleteReason
                        : ""
                    }
                    onChange={handleMetaDataChange}
                    InputProps={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    key="Delete Amount Refunded"
                    name="DeleteAmountRefunded"
                    label="Amount Refunded"
                    variant="outlined"
                    margin="normal"
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    value={
                      Attendee.MetaData &&
                      Attendee.MetaData.DeleteAmountRefunded
                        ? Attendee.MetaData.DeleteAmountRefunded
                        : ""
                    }
                    onChange={handleMetaDataChange}
                    InputProps={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    key="DeleteCreditCode"
                    name="DeleteCreditCode"
                    label="Credit Code Given"
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    value={
                      Attendee.MetaData && Attendee.MetaData.DeleteCreditCode
                        ? Attendee.MetaData.DeleteCreditCode
                        : ""
                    }
                    onChange={handleMetaDataChange}
                    InputProps={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    key="DeleteCreditCodeAmount"
                    name="DeleteCreditCodeAmount"
                    label="Delete Credit Code Amount"
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={
                      Attendee.MetaData &&
                      Attendee.MetaData.DeleteCreditCodeAmount
                        ? Attendee.MetaData.DeleteCreditCodeAmount
                        : ""
                    }
                    onChange={handleMetaDataChange}
                    InputProps={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                  />
                </Grid>
              </Grid>{" "}
              <Button
                variant="contained"
                sx={{
                  mt: 3,
                  ml: 1,
                  backgroundColor: "red",
                  "&:hover": { backgroundColor: "darkred" },
                }}
                onClick={(e) => handleArchive(e)}
                disabled={
                  IsArchiving ||
                  !Attendee.MetaData ||
                  !Attendee.MetaData["DeleteReason"] ||
                  !Attendee.MetaData["DeleteAmountRefunded"] ||
                  !Attendee.MetaData["DeleteCreditCode"] ||
                  !Attendee.MetaData["DeleteCreditCodeAmount"] ||
                  Attendee.MetaData["DeleteReason"] === "" ||
                  Attendee.MetaData["DeleteAmountRefunded"] === "" ||
                  Attendee.MetaData["DeleteCreditCode"] === "" ||
                  Attendee.MetaData["DeleteCreditCodeAmount"] === ""
                }
              >
                {IsArchiving ? "Archiving..." : "Are you Sure..."}
              </Button>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default ViewAttendee;
